<template>
  <div id="yaopin" :style="(list && list.length > 0)?'background:#fff':''">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      v-if="list && list.length > 0"
    >
      <div class="list" v-for="(item, index) in list" :key="index">
        <div class="line1">
          <span>[{{ item.goodsInternalId }}]&nbsp;</span>{{ item.brand }} {{ item.name }}
        </div>
        <div class="line2">
          <van-row type="flex">
            <van-col span="5">生产企业：</van-col>
            <van-col span="19">{{ item.manufacturer }}</van-col>
          </van-row>
        </div>
        <div class="line2">
          <van-row type="flex">
            <van-col span="5">药品条码：</van-col>
            <van-col span="19">{{ item.barCode }}</van-col>
          </van-row>
        </div>
        <div class="line3">
          <span>¥ {{ item.price }}</span
          >{{ item.specName }}
        </div>
      </div>
    </van-list>
    <van-empty description="暂无数据" v-else />
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: {
        skuNo: "",
        page: "1",
        limit: "15",
      },
      list: [],
      loading: false,
      finished: false,
    };
  },
  created() {
    this.page.skuNo = this.$route.query.skuNo;
    this.getData();
  },
  methods: {
    getData() {
      this.$api.yaopin(this.page).then((res) => {
        if (res.errno == "0") {
            this.list = this.list.concat(res.data.body);
          this.loading = false;
          // 数据全部加载完成
          if (res.data.body.length < 10) {
            this.finished = true;
          }
        }
      });
    },
    onLoad() {
      this.page.page++;
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
#yaopin {
  margin-top: 0.2rem;
  padding: 0 0.3rem;
  .list {
    padding: 0.4rem 0;
    border-bottom: 1px solid #eeeeee;
    .line1,
    .line2,
    .line3 {
      line-height: 1;
      padding-bottom: 0.3rem;
    }
    .line1 {
      line-height: 0.4rem;
      color: #333333;
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC;
      span {
        color: #00b095;
        font-size: 0.32rem;
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }
    .line2 {
      ::v-deep {
        .van-col {
          color: #666666;
          font-size: 0.28rem;
          line-height: 0.4rem;
          font-family: PingFangSC-Medium, PingFang SC;
        }
      }
    }
    .line3 {
      font-size: 0.28rem;
      color: #888888;
      padding-bottom: 0;
      span {
        color: #ff5d5d;
        font-size: 0.36rem;
        padding-right: 0.5rem;
        font-family: DINAlternate-Bold, DINAlternate;
      }
    }
    &:last-child {
      border-bottom: none;
    }
  }
  .van-empty {
    background: #f6f6f6;
  }
}
</style>
